import { ButtonBase, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	selected: boolean;
	onClick: () => void;
	label: string;
	icon: ReactNode;
	disabled?: boolean;
};

export const SelectableCardButton: FC<Props> = ({
	selected,
	onClick,
	label,
	icon,
	disabled,
}) => {
	const theme = useTheme();

	return (
		<ButtonBase
			type="button"
			disabled={disabled}
			onClick={onClick}
			sx={{
				flex: 1,
				width: "100%",
				flexDirection: "column",
				gap: 0.6,
				py: 1.2,
				borderRadius: theme.radii.lg,
				border: theme.colors.border.solid(
					selected ? theme.palette.blue[400] : theme.palette.grey[200],
				),
				bgcolor: selected
					? theme.palette.blue[50]
					: theme.palette.background.paper,
				opacity: disabled && !selected ? 0.45 : 1,
				transition: "all 120ms ease-out",
			}}
		>
			{icon}
			<Typography variant="button" color={theme.palette.grey[700]}>
				{label}
			</Typography>
		</ButtonBase>
	);
};
